module.exports = __webpack_public_path__ + "static/media/08_Title.bf8154ae.png";